import { environment } from "src/environment";
import type { InternalAxiosRequestConfig } from "axios";

const doesSupportsGroupCollapsed = String(console.groupCollapsed).includes(
  "code",
);

export function requestLogger(config: InternalAxiosRequestConfig) {
  (config as any)["_requested_at"] = Date.now();

  const lines = [];

  const {
    url = "Unknown URL",
    data,
    method = "Unknown method",
    baseURL = "Unknown base URL",
    params = {},
  } = config;

  const queryParams =
    (Object.keys(params).length ? "?" : "") +
    Object.entries(params)
      .map(([key, value]) => (value === undefined ? "" : key + "=" + value))
      .join("&");

  lines.push(
    `${method.toUpperCase()} ${url.replace(baseURL, "") + queryParams}`,
  );

  // TS error in axios
  const token = config.headers.Authorization;
  const tokenShort = token
    ? `${String(token).slice(0, 12)}…${String(token).slice(-5)}`
    : "No JWT set";
  lines.push(`Token: ${tokenShort}`);

  const maxLines = 320;
  const maxLineLength = 180;

  if (data) {
    const dataString = JSON.stringify({ data }, null, 2)
      .split("\n")
      .slice(0, maxLines)
      .map((line) =>
        line.length > maxLineLength
          ? line.slice(0, maxLineLength - 10) +
            "…" +
            line.slice(maxLineLength - 10, 9)
          : line,
      )
      .join("\n");
    lines.push(`${dataString}`);
  }

  const pretty = lines
    .join("\n")
    .split("\n")
    .map((l) => "> " + l);
  pretty.push("");

  const urlReplaced = url.replace(environment.TOS_API_URL, "/");

  const groupTitle = `${method.toUpperCase()} ${
    urlReplaced + queryParams
  } | Token: ${tokenShort}`;

  if (doesSupportsGroupCollapsed) {
    (console as any).groupCollapsed("%c" + groupTitle, "color: #997a00");
    console.log(pretty.join("\n"));
    console.groupEnd();
  } else {
    // Make messages appear yellow in console
    console.log("\x1b[33m%s\x1b[0m", groupTitle);

    // Uncomment if you want to log request data in the console
    pretty.splice(0, 2, groupTitle);
    console.log(
      pretty
        .map((line, index) => (index === 0 ? line : `      ${line}`))
        .join("\n"),
    );
  }

  return config;
}
